module.exports = __webpack_public_path__ + "img/664.b3b7292e.jpg";